<div class="relative lg:p-0 p-3">
  <!-- <iframe class="w-full h-lvh  "
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d48389.78314118045!2d-74.006138!3d40.710059!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a22a3bda30d%3A0xb89d1fe6bc499443!2sDowntown%20Conference%20Center!5e0!3m2!1sen!2sus!4v1676961268712!5m2!1sen!2sus"
          frameborder="0">
  </iframe> -->
    <google-map class="w-full h-lvh"  #mapElement [height]="mapHeight" width="100%" [center]="center">
    </google-map>
  <div [style.pointer-events]="isCompleted || !TicketLocationWrite ? 'none' : 'auto'"
    class="absolute top-[150px] left-[90px] bg-white  rounded-xl w-[366px] p-8 ease-in-out duration-200 shadow-md z-[75]">
    <div class="mb-3">
      <h3 class="font-medium text-lg leading-6 text-[#15191E] mb-2">Location and Area</h3>
      <p class="font-normal text-sm leading-5 text-[#60646C]">Add location and area details.</p>
    </div>
    <form class="form" [formGroup]="locationAndAreaForm">
      <div class="grid grid-cols-1 gap-4">
        <div>
          <label class="field-label required " for="Location">Location</label>
          <app-select
                    id="Location" [closeOnSelect]="false" [appendToBody]="false"
                    placeHolder="Location"
                    formControlName="locationValues"
                    [pageResult]="siteService.siteChild$ | async"
                    (clear)="siteService.fetchSiteByParent($event, siteType)"
                    (scrollEnd)="
                      siteService.fetchNextSitesByParent(
                        $event,
                        siteType,
                        null,
                        [facilitySearch]
                      )
                    "
                    (search)="
                      siteService.searchInSitesByParent(
                        $event,
                        siteType,
                        null,
                        [facilitySearch]
                      )
                    "
                    (selectionChanged)="onChangeLocation($event)"
                    [clearSelectedValue]="!stSearch"
                    [multiple]="true"
                    [showRefresh]="false"
                    [isClearAble]="true"

                  >
                    <!-- Only load data when parent is selected -->
          </app-select>
        </div>

        <div>
          <label class="field-label required" for="Area">Area</label>
           <app-select-multilevel
              formControlName="areaValues"
              placeHolder="Select Area"
              bindLabel="name"
              bindValue="id"
              [groupBy]="'parentName'"
              [pageResult]="areaListAll"
              [multiple]="true"
              (selectionChanged)="onChangeArea()"
              [closeOnSelect]="false">
            </app-select-multilevel>
        </div>
        <bk-button 
          variant="primary"
          label="Update Location"
          size="sm"
          [disabled]="isLoading" 
          buttonClass="text-white bg-[#141414] w-full !py-[5px] rounded-md" 
          (click)="updateLocationAndArea()" 
          [disabled]="!locationAndAreaForm.get('locationValues')?.value?.length || !locationAndAreaForm.get('areaValues')?.value?.length">
        </bk-button>
      </div>

    </form>

  </div>
</div>
